import Vimeo from '../../../components/video-player/'
import Option from '../../../components/menu-options/'
import Menu from '../../../components/menu/'
import Context from '../../../assets/data/context.json'

export default {
  name: 'home',
  data () {
    return {
      vimeoVideoID: (this.$lang.videoID !== undefined ? this.$lang.videoID : '240698733'),
      section2: {
        options: {
          autoplay: 0,
          autopause: 0
        }
      },
      removeLoader: false,
      hasLoadedVideo: false,
      context: Context
    }
  },
  mounted () {
    this.$nextTick(function () {
      window.scrollTo(0, 0)
    })

    let self = this
    this.$bus.$on('LANGUAGE.CHANGE', () => {
      self.buildOptions()
    })

    this.$bus.$on('VIDEO.LOADED', () => {
      this.hasLoadedVideo = true
    })

    this.util.addBodyClass('blue-bg')
  },
  beforeDestroy () {
    this.util.removeBodyClass('blue-bg')
  },
  methods: {
    clickToPlayVideo () {
      if (this.hasLoadedVideo) {
        this.removeLoader = true
        this.$bus.$emit('VIDEO.PLAYVIDEO')
      }
    },
    changeLang (lang) {
      if (this.$lang.currentLang === undefined || this.$lang.currentLang !== lang) {
        this.$setLang(lang)
        this.$bus.$emit('LANGUAGE.CHANGE')
      }
    }
  },
  components: {
    'menu-co': Menu,
    'video-player': Vimeo,
    'menu-option': Option
  }
}



// WEBPACK FOOTER //
// ./src/components/content/home/logic.js